module.exports = __webpack_public_path__ + "assets/images/cdd39d6a5c8f17cfcbabb969fa635414.png";